import moment from 'moment'
import React from 'react'

const Comments = ({ comments }) => {
  return (
        comments.length > 0 ?
                comments.map((comment, index) => (
                    <div className="comments">
                    <div className="comments-box" key={index}>
                        <div className="content">
                            <div className="author">
                                <img src={comment.user.profilePicture ?  comment.user.profilePicture : ""} alt="" />
                                    <div className="name-date">
                                        <div className="name">{comment.user.firstName + " " + comment.user.lastName}</div>
                                        <div className="date">{moment(comment.updatedAt).format("MMM Do YYYY")}</div>
                                    </div>
                            </div>
                        </div>
                            <div className="comment">
                                {comment.comment}
                            </div>
                     </div>
                     </div>
                ))
                :
                ",snakjsd"
  )
}

export default Comments